export default __webpack_public_path__ + "images/606f89eaf60e079da7e6ed77bf2d866d-dte.svg";